import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AppStoreService } from '../../store/ngrx-signal.store';
import { ENTITIES } from '../../store/entities.registry';
import { LOGGED_IN_USER } from '../../modules/user-profile/user-profile.models';

export const moduleSelectionGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const store = inject(AppStoreService);
  const router = inject(Router);

  let user = store.snapshot<any>(ENTITIES.LOGIN_USER)?.[0];
  if (!user) {
    try {
      await store.query(ENTITIES.LOGIN_USER, LOGGED_IN_USER);
      user = store.snapshot<any>(ENTITIES.LOGIN_USER)?.[0];
    } catch (e) {
      console.error('Failed to fetch user in moduleSelectionGuard:', e);
    }
  }

  if (user) {
    const userType = (user?.userType || user?.institutionUserType || '').toUpperCase();
    const roleName = (user?.role?.name || '').toUpperCase();
    const isSuperAdmin =
      userType === 'SUPER_ADMIN' ||
      userType === 'ADMIN' ||
      roleName === 'SUPER ADMIN' ||
      roleName === 'SUPERADMIN';

    if (!isSuperAdmin) {
      return router.createUrlTree(['/modules']);
    }
  }

  return true;
};
